import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App.tsx'
import './index.css'

const APP_ENV = import.meta.env.VITE_APP_ENV as string | undefined;

Sentry.init({
  dsn: "https://b3edf481b013d261e8c4d44f91c9c690@o4511149040205824.ingest.de.sentry.io/4511149050626128",
  // Only capture and send errors in production — local and staging errors are ignored.
  enabled: APP_ENV === "production",
  // Tag every event with the environment so the Sentry dashboard can filter by it.
  environment: APP_ENV ?? "development",
  sendDefaultPii: true,
});

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
      gcTime: 1000 * 60 * 30, // Keep unused data in cache for 30 minutes
      retry: 1, // Retry failed requests once
      refetchOnWindowFocus: true, // Refetch when user comes back to tab
    },
    mutations: {
      retry: 0, // Don't retry mutations by default
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
    <ReactQueryDevtools
      initialIsOpen={false}
      position="bottom"
    />
  </QueryClientProvider>
);
